var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentanalysis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.015,
    height: 54.852,
    viewBox: "0 0 53.015 54.852",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(30.735 6.156)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.687,62.148a.815.815,0,0,0-1.329.945,9.512,9.512,0,1,1-1.85-1.949.815.815,0,1,0,1.013-1.277,11.024,11.024,0,0,0-6.919-2.408,11.138,11.138,0,1,0,9.084,4.69Z",
    transform: "translate(-295.463 -57.458)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.585,30.186A.815.815,0,0,0,49.77,31V50.553A2.672,2.672,0,0,1,47.1,53.222H12.87A2.671,2.671,0,0,1,10.2,50.553V10.583H40.014a.815.815,0,1,0,0-1.63H10.2V4.3A2.671,2.671,0,0,1,12.87,1.63H47.1A2.672,2.672,0,0,1,49.77,4.3a.815.815,0,0,0,1.63,0A4.3,4.3,0,0,0,47.1,0H12.87a4.3,4.3,0,0,0-4.3,4.3V50.553a4.3,4.3,0,0,0,4.3,4.3H47.1a4.3,4.3,0,0,0,4.3-4.3V31A.815.815,0,0,0,50.585,30.186Z",
    transform: "translate(-8.572)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 15.352)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.962,143.293h-18.1a.815.815,0,1,0,0,1.63h18.1a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-89.052 -143.293)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.984 15.362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7,144.031a.815.815,0,1,0-.535.929A.821.821,0,0,0,56.7,144.031Z",
    transform: "translate(-55.092 -143.385)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 24.46)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.962,228.31h-18.1a.815.815,0,1,0,0,1.63h18.1a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-89.052 -228.31)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.98 24.469)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.454,228.626a.815.815,0,1,0,.078,1.062A.823.823,0,0,0,56.454,228.626Z",
    transform: "translate(-55.062 -228.397)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.945 29.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M284.678,270.819H279.57a.815.815,0,1,0,0,1.63h5.107a.815.815,0,1,0,0-1.63Z",
    transform: "translate(-278.755 -270.819)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.719 29.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174.954,270.819h-9.509a.815.815,0,1,0,0,1.63h9.509a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-164.63 -270.819)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 29.014)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,270.819h-5.38a.815.815,0,1,0,0,1.63h5.38a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-89.052 -270.819)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.981 29.021)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.457,271.114a.815.815,0,1,0,.106,1.021A.822.822,0,0,0,56.457,271.114Z",
    transform: "translate(-55.065 -270.882)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 33.568)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.072,313.328h-13.2a.815.815,0,1,0,0,1.63h13.2a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-89.052 -313.328)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.983 33.578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.7,314.068a.815.815,0,1,0-.444.892A.821.821,0,0,0,56.7,314.068Z",
    transform: "translate(-55.09 -313.422)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(27.478 38.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.374,355.836h-2.5a.815.815,0,1,0,0,1.63h2.5a.815.815,0,1,0,0-1.63Z",
    transform: "translate(-265.06 -355.836)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.534 38.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.28,355.836h-7.227a.815.815,0,1,0,0,1.63h7.227a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-172.238 -355.836)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 38.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.062,355.836H89.867a.815.815,0,1,0,0,1.63h6.195a.815.815,0,1,0,0-1.63Z",
    transform: "translate(-89.052 -355.836)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.981 38.129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.457,356.131a.815.815,0,1,0,.106,1.022A.822.822,0,0,0,56.457,356.131Z",
    transform: "translate(-55.065 -355.899)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22.098 42.676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.289,398.346H215.66a.815.815,0,0,0,0,1.63h11.628a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-214.845 -398.346)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 42.676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.626,398.346H89.867a.815.815,0,1,0,0,1.63h10.759a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-89.052 -398.346)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.984 42.685)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.71,399.078a.815.815,0,1,0-.563.939A.821.821,0,0,0,56.71,399.078Z",
    transform: "translate(-55.099 -398.431)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 47.23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.247,440.855h-5.38a.815.815,0,0,0,0,1.63h5.38a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-89.052 -440.855)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.982 47.241)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.646,441.45a.815.815,0,1,0-.365,1.029A.821.821,0,0,0,56.646,441.45Z",
    transform: "translate(-55.079 -440.957)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.622 19.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.943,185.8H89.867a.815.815,0,1,0,0,1.63h4.075a.815.815,0,0,0,0-1.63Z",
    transform: "translate(-89.052 -185.801)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.632 19.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.123,185.8H155.3a.815.815,0,0,0,0,1.63h7.825a.815.815,0,1,0,0-1.63Z",
    transform: "translate(-154.483 -185.801)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.984 19.915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.707,186.535a.815.815,0,1,0-.535.93A.821.821,0,0,0,56.707,186.535Z",
    transform: "translate(-55.095 -185.889)",
    fill: "#0080ff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.659 11.835)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M360.751,110.558a.815.815,0,0,0-1.1.342l-4.364,8.292-3.13-3.26a.815.815,0,1,0-1.176,1.129l3.913,4.075a.815.815,0,0,0,.588.251.8.8,0,0,0,.114-.008.815.815,0,0,0,.607-.427l4.891-9.292A.815.815,0,0,0,360.751,110.558Z",
    transform: "translate(-350.753 -110.464)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentanalysis);
export default __webpack_public_path__ + "static/media/documentanalysis.c069c165.svg";
export { ForwardRef as ReactComponent };